import Vue from 'vue'
import {getWithPagination, NotificationsResource} from '../../util/api'

const initialState = {
  objects: {},
  getInProgress: false, // Is a GET request in progress for this Store?
  createInProgress: false, // Is a GET request in progress for this Store?
  updateInProgress: false, // Is a POST or PUT request in progress for this Store?
  deleteInProgress: false // Is a DELETE request in progress for this Store?
}

export default {
  state: { ...initialState },
  mutations: {
    SET_NOTIFICATIONS (state, objects) {
      let updatedObjects = {}
      for (let key in objects) {
        if (objects.hasOwnProperty(key)) {
          if (objects[key].deleted_at === null) {
            // Stage the update so we can just do one Vue.set
            updatedObjects[objects[key].id] = objects[key]
          } else if (state.objects.hasOwnProperty(objects[key].id)) {
            // Immediately delete the object
            Vue.delete(state.objects, objects[key].id)
          }
        }
      }
      state.objects = {
        ...state.objects,
        ...updatedObjects
      }
    },
    SET_NOTIFICATION (state, object) {
      if (object.deleted_at === null) {
        Vue.set(state.objects, object.id, object)
      } else {
        Vue.delete(state.objects, object.id)
      }
    },
    UNSET_NOTIFICATION (state, object) {
      Vue.delete(state.objects, object.id) // Vue will take care of wether the key is even in the runningNotifications list
    },
    DELETED_NOTIFICATION (state, object) {
      state.updatedObject = object
    },

    // Progress States
    GET_NOTIFICATION_IN_PROGRESS (state, value) {
      state.getInProgress = value
    },
    DELETE_NOTIFICATION_IN_PROGRESS (state, value) {
      state.deleteInProgress = value
    },

    NOTIFICATIONS_CLEAR_ALL (state) {
      for (let key in initialState) {
        Vue.set(state, key, initialState[key])
      }
    }
  },

  actions: {
    clearTaskNotifications ({ state, dispatch }, task) {
      for (let k in state.objects) {
        if (state.objects.hasOwnProperty(k) && state.objects[k].task_id === task.id) {
          dispatch('deleteNotification', state.objects[k])
        }
      }
    },
    // Retrieve many notificaions, based on supplied GET params
    getNotifications ({ commit }, params) {
      // Check if we have an up-to-date version of the object. If not, get it.
      commit('GET_NOTIFICATION_IN_PROGRESS', true)
      getWithPagination(NotificationsResource, params, response => {
        // Note: Pagination requests return the objects under the 'data' key
        commit('SET_NOTIFICATIONS', response.body.data)
      }, () => {
        // Completion handler
        commit('GET_NOTIFICATION_IN_PROGRESS', false)
      }, () => {
        // Error handler
        commit('GET_NOTIFICATION_IN_PROGRESS', false)
      })
    },

    deleteNotification ({ commit }, object) {
      // Update (PUT) a NOTIFICATION
      commit('DELETED_NOTIFICATION', null)
      commit('DELETE_NOTIFICATION_IN_PROGRESS', object)
      NotificationsResource.delete({id: object.id}).then(() => {
        commit('DELETE_NOTIFICATION_IN_PROGRESS', false)
        commit('DELETED_NOTIFICATION', object)
        commit('UNSET_NOTIFICATION', object)
      }, () => {
        commit('DELETE_NOTIFICATION_IN_PROGRESS', false)
        commit('DELETED_NOTIFICATION', null)
      })
    },

    clearAll ({ commit }) {
      commit('NOTIFICATIONS_CLEAR_ALL')
    }
  }
}
